<ng-template #UpdateMobileCheckPIN>
    <div class="centered-content">
        <div
            style="display: flex; justify-content: center; align-items: center; flex-direction: column; background: #e6e6e6">
            <div
                style="max-width: 736px; width: 100%; height: auto; margin: 0 auto; padding: 20px 44px 40px; background: #fff">
                <div nxLayout="grid maxwidth">
                    <div nxRow>
                        <div nxCol="12" style="text-align: center;">
                            <h3 nxHeadline="subsection-medium" translate>
                                profile.texts.check-sms-code</h3>
                        </div>
                    </div>
                    <form [formGroup]="form" class="modal-form-report" (submit)="checkSMSCode($event)">
                        <div nxRow>
                            <div nxCol="12">
                                <nx-formfield label="{{ 'profile.texts.sms-code' | translate }}">
                                    <input required nxInput type="text" [class]="isRed()"
                                        nxAriaLabel="{{ 'profile.texts.sms-code' | translate }}"
                                        formControlName="smsCode" />
                                </nx-formfield>
                            </div>
                            <div nxCol="12" class="nx-margin-bottom-m resend-sms">
                                <nx-link>
                                    <a href="javascript:void(0);" (click)="resend()" translate>profile.texts.resent-sms-code</a>
                                </nx-link>
                            </div>
                            <div nxCol="12">
                                <div nxRow rowJustify="center">
                                    <button nxButton="primary normal" type="submit">
                                        <span translate>profile.texts.send</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</ng-template>